// import Vue, { PluginObject } from 'vue';
import axios from "axios";
import router from "@/router/index";
import { Message } from "element-ui";
import store from '@/store'
import i18n from '../plugins/locales/index'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const origin = location.hostname; //当前访问域名
let requestBase = "";

if (process.env.NODE_ENV === "development") {
  requestBase = process.env.VUE_APP_BASE_API;
} else {
  if (origin.indexOf("-testserver") > -1) {
    requestBase = process.env.VUE_APP_BASE_API_DEV;
  } else {
    requestBase = process.env.VUE_APP_BASE_API_MASTER;
  }
}
const config = {
  baseURL: requestBase,
  timeout: 60 * 1000,
  withCredentials: true
};
function isZh() {
  const loc =
    (i18n && i18n.locale) ||
    localStorage.getItem("locale") ||
    navigator.language ||
    "zh-CN";
  return String(loc).toLowerCase().indexOf("zh") === 0;
}

/**
 * 从后端 error 对象里按语言挑字段
 * ⚠️ 字段名 returnUserMessage / returnMessageEn 请按你后端实际返回结构调整
 */
function pickErrorMsg(error:any) {
  if (!error) return "";
  if (isZh()) {
    return error.returnUserMessage || error.returnMessage || "";
  }
  return error.returnUserMessageEn || error.returnMessage || error.returnUserMessage || "";
}
const _axios = axios.create(config);

_axios.interceptors.request.use(
  cfg => {
      // 在发送请求之前做些什么
    // if (store.getters.token) {
    //   // 如果有 token，将其添加到请求头
    //   cfg.headers['cookie'] = store.getters.token
    // }
    // Do something before request is sent
    return cfg;
  },
  err => {
    // Do something with request error
    return Promise.reject(err);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  res => {
    const { error } = res.data;
    if (error.returnCode !== 0) {
      if (error.returnCode === 10001) {
        return
      }
      // Message.error(error.returnMessage || Error);
      const msg = pickErrorMsg(error) || "Error";
      Message.error(msg);
      return Promise.reject(new Error(msg || "Error"));
    } else {
      return res.data.data;
    }
  },
  err => {
    const msg = pickErrorMsg(err) || "Error";
    Message({
      message: msg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(err);
  }
);

export default _axios;
